export default function VehiculesConfiguration($translatePartialLoaderProvider) {
    $translatePartialLoaderProvider.addPart('vehicules');
}

VehiculesConfiguration.$inject = ['$translatePartialLoaderProvider'];
